<!--File: cgp-sidenav.template.html-->
<!--Author: Joseph M Diaz-->
<!--Date: 5/10/2017-->
<!--Desc: Sidenav component.-->
<!--Other Contributors:-->

<div class="cgp-sidenav">
    <div *ngFor="let item of items">
        <cgp-sidenav-item [item]="item"></cgp-sidenav-item>
    </div>

</div>
